﻿<script>
	import { tick } from "svelte";

	export let id;
	export let label;
	export let value;
	export let maxlength = null;
	export let minlength = null;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let allowDecimal = false;

	const handleKeyDown = (e) => {
		if (
			e.key == "Backspace" ||
			e.key == "Delete" ||
			e.key == "ArrowLeft" ||
			e.key == "ArrowRight" ||
			e.key === "Enter"
		) {
			return true;
		}
	};

	const handleKeyPress = (e) => {
		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter") {
			return true;
		}

		if (e.key.match(/\d/)) {
			return true;
		}

		if (allowDecimal && e.key === "." && value != null && !String(value).includes(".")) {
			return true;
		}

		e.preventDefault();
		return false;
	};

	const handlePaste = async (e) => {
		var pattern = allowDecimal ? /[^\d.]/g : /\D/g;
		var pastedText = e.clipboardData.getData("text").replace(pattern, "");

		if (allowDecimal) {
			let parts = pastedText.split(".");
			pastedText = parts.shift() + (parts.length ? "." + parts.join("") : "");
		}

		var start = e.target.selectionStart;
		var end = e.target.selectionEnd;
		var currentVal = value ? String(value) : "";

		var resultingValue = currentVal.substring(0, start) + pastedText + currentVal.substring(end);

		if (allowDecimal) {
			let dotParts = resultingValue.split(".");
			resultingValue = dotParts.shift() + (dotParts.length ? "." + dotParts.join("") : "");
		}

		if (maxlength) resultingValue = resultingValue ? resultingValue.substring(0, maxlength) : "";
		value = resultingValue;

		await tick();
		e.target.setSelectionRange(start, end);

		e.preventDefault();
		return false;
	};
</script>

{#if label}<label for={id} class:isrequired={required}>{label}</label>{/if}
<input
	{required}
	{disabled}
	{readonly}
	{maxlength}
	{minlength}
	type="text"
	inputmode={allowDecimal ? "decimal" : "numeric"}
	bind:value
	{id}
	class="form-control"
	on:keydown={handleKeyDown}
	on:keypress={handleKeyPress}
	on:paste={handlePaste} />
